import { createValidator, richTextMaxLength } from 'util/validation'

import { OdontologiaModel } from './evolucoes-odontologicas/EvolucoesOdontologicasView'
import { periogramaCompletoValidator } from './evolucoes-odontologicas/periograma/periograma-completo/periograma-completo-table-field/validator'
import { periogramaSimplificadoValidator } from './evolucoes-odontologicas/periograma/periograma-simplificado/validator'
import { PeriodontiaModel } from './evolucoes-odontologicas/periograma/PeriogramaView'
import { PlanoFormModel } from './PlanoForm'

export const planoValidator = createValidator<PlanoFormModel>({
  texto: [richTextMaxLength(4000)],
  odontologia: createValidator<OdontologiaModel>({
    periodontia: createValidator<PeriodontiaModel>({
      periogramaSimplificado: periogramaSimplificadoValidator,
      periogramaCompleto: periogramaCompletoValidator,
    }),
  }),
})
